import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment.prod'
// Removed Firestore modular imports as they're unused with AngularFirestore compat
import { Firestore, collection, doc, docData, collectionData, query, orderBy } from '@angular/fire/firestore';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ProductsService {

  private firestore = inject(Firestore);

  getProducts(userId: string, appId: string): Observable<any[]> {
    const productsRef = collection(this.firestore, `Users/${userId}/Apps/${appId}/Products`);
    const productsQuery = query(productsRef, orderBy('created_at', 'desc'));
    return collectionData(productsQuery, { idField: 'id' });
  }

  getProductById(userId: string, appId: string, productId: string): Observable<any> {
    const productRef = doc(this.firestore, `Users/${userId}/Apps/${appId}/Products/${productId}`);
    return docData(productRef, { idField: 'id' });
  }


  createOrUpdate(data: any){
    return this.http.post(environment.apiUrl + "auth/createOrUpdate/product/", data);
  }

  delete(data: any){
    return this.http.post(environment.apiUrl + 'auth/delete/product', data)
  }

  setShow(data: any){
    return this.http.post(environment.apiUrl + "auth/set/product/show", data);
  }

  upload(file: File, data: any): Observable<any> {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('appId', data?.appId);
    formData.append('userId', data?.userId);
    formData.append('productId', data?.productId);
    return this.http.post(environment.apiUrl  + "auth/upload/product/image", formData).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('An error occurred', error); // log the error

    return throwError(error.message || 'Server Error');
  }

  constructor(private http: HttpClient) { }

}
